
import { Component, Vue, Prop } from 'vue-property-decorator'

const NoPicture = require('@/assets/no_picture_available.png')

@Component
export default class PickStep extends Vue {
  @Prop({ type: Object, required: true }) readonly product!: any

  @Prop({ type: Object, default: null }) readonly currentLocation!: any

  noPicture = NoPicture

  // --- COMPUTED ---
  get productImage (): any {
    return this.product.images ? `${this.product.images}?fm=webp&w=140&h=140` : this.noPicture
  }
}
